var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "59px",
    height: "59px",
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Abstract/13",
    transform: "translate(-3.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,9 C44.7025492,9 55,19.2974508 55,32 C55,44.7025492 44.7025492,55 32,55 C19.2974508,55 9,44.7025492 9,32 C9,19.2974508 19.2974508,9 32,9 Z M32,19 C24.8202983,19 19,24.8202983 19,32 C19,39.1797017 24.8202983,45 32,45 C39.1797017,45 45,39.1797017 45,32 C45,24.8202983 39.1797017,19 32,19 Z",
    id: "Combined-Shape",
    fill: "#9AE0EA",
    className: "fill-dynamic-2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    className: "icon-color-base",
    transform: "translate(31.898817, 31.728223) rotate(-270.000000) translate(-31.898817, -31.728223) ",
    x: 2.82189378,
    y: 30.7282228,
    width: 58.1538462,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFE8AC",
    className: "fill-dynamic-1",
    x: 3,
    y: 26,
    width: 58.1538462,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFE8AC",
    className: "fill-dynamic-1",
    x: 3,
    y: 34,
    width: 58.1538462,
    height: 4,
    rx: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon13);
export default __webpack_public_path__ + "static/media/icon13.849d32ff0c91aac9e4df1d806aeed7c8.svg";
export { ForwardRef as ReactComponent };